import { useTranslation } from 'react-i18next';
import { Form, Formik } from 'formik';

import ErrorSnackbar from 'src/components/common/Snackbar/ErrorSnackbar';
import SuccessSnackbar from 'src/components/common/Snackbar/SuccessSnackbar';

import { useSurveyDetailQuery, useSurveyUpdateQuery } from '../api';

import FollowUpModuleSettings from './FollowUpModule/FollowUpModuleSettings';
import GeneralSettings from './General/GeneralSettings';
import FormButtonRow from './FormButtonRow';
import { validationSchema } from './validationSchema';

import { styles } from '../index.styles';

const SurveySettingsForm = () => {
  const { t } = useTranslation('survey');
  const { data: survey, refetch } = useSurveyDetailQuery();
  const { mutateAsync, error, isSuccess, reset } = useSurveyUpdateQuery();

  return (
    <>
      {survey && (
        <Formik
          initialValues={survey}
          onSubmit={(values, { setValues }) => {
            mutateAsync(values).then(() =>
              refetch().then(
                ({ data: updatedSurvey }) =>
                  updatedSurvey && setValues(updatedSurvey),
              ),
            );
          }}
          validationSchema={validationSchema(t)}
          validateOnChange={false}
        >
          <Form style={styles.settingsContainer}>
            <GeneralSettings />
            <FollowUpModuleSettings />
            <FormButtonRow />
          </Form>
        </Formik>
      )}
      <SuccessSnackbar
        onClose={reset}
        open={isSuccess}
        title={t('settings.success')}
        message={t('settings.successMessage')}
      />
      <ErrorSnackbar onClose={reset} open={error} title={t('settings.error')} />
    </>
  );
};

export default SurveySettingsForm;
